import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const useSnackbar = () => {

  const SuccessSnackbar = (message, position = "bottom-left") =>
    toast(<p style={{ fontSize: 16 }}>{message}</p>, {
      position: position,
      autoClose: 5000,
      hideProgressBar: false,
      newestOnTop: false,
      closeOnClick: true,
      rtl: false,
      pauseOnFocusLoss: true,
      draggable: true,
      pauseOnHover: true,
      type: "success"
    });

  const ErrorSnackbar = (message, position = "bottom-left") =>
    toast(<p style={{ fontSize: 16 }}>{message}</p>, {
      position: position,
      autoClose: 5000,
      hideProgressBar: false,
      newestOnTop: false,
      closeOnClick: true,
      rtl: false,
      pauseOnFocusLoss: true,
      draggable: true,
      pauseOnHover: true,
      type: "error"
    });

  const InfoSnackbar = (message, position = "bottom-left") =>
    toast(<p style={{ fontSize: 16 }}>{message}</p>, {
      position: position,
      autoClose: 5000,
      hideProgressBar: false,
      newestOnTop: false,
      closeOnClick: true,
      rtl: false,
      pauseOnFocusLoss: true,
      draggable: true,
      pauseOnHover: true,
      type: "info"
    });

  const WarningSnackbar = (message, position = "bottom-left") =>
    toast(<p style={{ fontSize: 16 }}>{message}</p>, {
      position: position,
      autoClose: 5000,
      hideProgressBar: false,
      newestOnTop: false,
      closeOnClick: true,
      rtl: false,
      pauseOnFocusLoss: true,
      draggable: true,
      pauseOnHover: true,
      type: "warning"
    });


  return {
    SuccessSnackbar,
    ErrorSnackbar,
    InfoSnackbar,
    WarningSnackbar,
    ToastContainer
  };
};

export default useSnackbar;
